<template>
    <div class="cents">
        <van-nav-bar
        :title="this.$t('sb')"
		:right-text="UserInfo.person_type == 2 ? this.$t('tj') :''"
        left-arrow
        safe-area-inset-top
        style="background-color: #1ABC9C;"
        @click-left="goto"
		@click-right="goSearch"
        />
        <!-- 蓝牙不可用弹窗 -->
        <div v-if="showBluetoothDialog" class="bluetooth-overlay" @click="closeDialog">
            <div class="bluetooth-modal" @click.stop>
                <div class="modal-header">
                    <div class="warning-icon">
                        <van-icon name="warning-o" size="40" color="#fff" />
                    </div>
                    <!-- <span class="modal-title">蓝牙功能不可用</span> -->
                </div>
                <div class="modal-body">
                     <p>{{$t('应用不支持蓝牙功能')}} </p>
                </div>
                <div class="modal-footer">
                    <button class="btn-copy" @click="copyLink">{{$t('复制链接')}}</button>
                    <button class="btn-open" @click="openInBrowser">{{$t('中打开')}}</button>
                </div>
            </div>
        </div>
        <div class="requist">
            <van-field
            :border="true"
            clearable
            size='large'
            v-model="keyword"
            :placeholder="$t('sbmhzwz')"
            />
            <van-button color="#1ABC9C" size="small" @click="questlist">{{$t('cxwz')}}</van-button>
        </div>
        <div class="equtcont">
            <!-- <h4>风华一区</h4> -->
           <!-- <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="$t('mygd')"
                @load="onLoad"
            > -->
                <div class="" v-for="(item,index) in equdatalist" :key="item.id">
                    <div class="costplas " >
                        <div :class="item.is_online? 'yuan colorsold ': 'yuan colors' " @click="handleDevice(item.serial_number,index)">
                            <!-- <h2>{{item.is_online?'在线':'离线'}}</h2> -->
                            <van-icon name="wap-home" />
                        </div>
                    <div style="text-align: left;">
                        
                            <p style="line-height:30px">{{weiz}}:{{item.name}}</p>
                            <p>{{xlh}}:{{item.serial_number}}</p>
                    </div>
                    </div>
                </div>
            <!-- </van-list> -->
        </div>
        <!-- 分页 -->
        <div class="data-load-more" v-if="deviceCount>10||Math.ceil(deviceCount/page_size)>1">
        	<div @click="goTop">{{this.$t('syy')}}</div>
        	<div style="width: 25px;" @click="pageTop" v-if="pageSizeList[0]!=1">...</div>
        	<div class="pageSizeBox">
        		<div v-for="(item,index) in pageSizeList" :key="index" style="width: 25px;" @click="handlePageSize(item)" :class="[page_index==item?'pageSizeItemState':'']">
        			{{item>pageSize?'':item}}
        		</div>
        	</div>
        	<div style="width: 25px;" @click="pageBottom" v-if="pageSize>pageSizeList[4]">...</div>
        	<div @click="goBottom">{{this.$t('xyy')}}</div>
        </div>
        <div style="padding-bottom:80px">

        </div>
        <Footer :person_type="UserInfo.person_type"></Footer>  
    </div>
</template>
<script>
import WebApp from '@twa-dev/sdk';
export default {
    data(){
        return{
            loading:false,
            finished: false,
            UserInfo:JSON.parse(window.localStorage.getItem("getTokendata")),
            page_size:10,
            keyword:"",
            equdatalist:[],
            page_index:1,
            count:null,
            weiz:this.$t('sbwz'),
            xlh:this.$t('xlh'),
			deviceCount:0, // 接口返回设备数量
			pageSize:0, // 设备页数
			pageSizeList:[1,2,3,4,5], // 页码
            showBluetoothDialog: false, // 蓝牙不可用弹窗状态
        }
    },
    mounted(){
        this.getEquiplist()
    },
    methods:{
		// 点击装置
		handleDevice(e,index) {
            
            // return false
			if(this.UserInfo.person_type == 2){
                let equdatalistDate = JSON.stringify(this.equdatalist[index])
                // console.log(e,index,equdatalistDate)
				this.$router.push({path:'/netlist',query:{serial_number:e,deviceInfo:equdatalistDate}})
			}
			// this.$router.push(`/netlist?serial_number=${e},deviceInfo=${equdatalistDate}`)
		},
        isInTelegram() {
            var sUserAgent = navigator.userAgent.toLowerCase();
            return sUserAgent.indexOf('telegram') !== -1;
        },
		// 搜索设备 页面
		goSearch(){
			// 获取本地存储的用户ID
			const telgarmId = localStorage.getItem('telgarmId');
            if (telgarmId ||this.isInTelegram() && window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.openLink) {
                this.showBluetoothDialog = true;
                return;
            }
			this.$router.push('/deviceSearch')
		},
		// 关闭弹窗
		closeDialog() {
			this.showBluetoothDialog = false;
		},
		// 复制当前链接
		copyLink() {
			const url = window.location.href;
			// 尝试使用现代 API
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(url).then(() => {
					this.$toast.success(this.$t('链接已复制'));
					this.showBluetoothDialog = false;
				}).catch(() => {
					this.fallbackCopy(url);
				});
			} else {
				this.fallbackCopy(url);
			}
		},
		// 备用复制方法
		fallbackCopy(text) {
			const textarea = document.createElement('textarea');
			textarea.value = text;
			textarea.style.position = 'fixed';
			textarea.style.left = '-9999px';
			document.body.appendChild(textarea);
			textarea.select();
			try {
				const successful = document.execCommand('copy');
				if (successful) {
					this.$toast.success('链接已复制');
					this.showBluetoothDialog = false;
				} else {
					this.showCopyManual(text);
				}
			} catch (err) {
				this.showCopyManual(text);
			} finally {
				document.body.removeChild(textarea);
			}
		},
		// 显示手动复制提示
		showCopyManual(text) {
			this.$toast.fail('复制失败，请手动复制链接');
			// 创建临时提示显示链接
			const promptDiv = document.createElement('div');
			promptDiv.style.cssText = `
				position: fixed;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				background: #333;
				color: #fff;
				padding: 20px;
				border-radius: 8px;
				z-index: 2000;
				max-width: 80%;
				word-break: break-all;
				text-align: center;
			`;
			promptDiv.innerHTML = `<p style="margin-bottom: 10px;">请复制以下链接：</p><p style="font-size: 12px;">${text}</p>`;
			document.body.appendChild(promptDiv);
			setTimeout(() => {
				document.body.removeChild(promptDiv);
			}, 5000);
		},
		// 在浏览器中打开
		openInBrowser() {
			WebApp.openLink(window.location.href, { tryBrowser: 'google-chrome', try_instant_view: true });
			this.showBluetoothDialog = false;
		},
        goto(){
            if (window.history.length > 1) {
                this.$router.go(-1);
            } else {
                // 如果没有上一页，返回首页
                this.$router.push('/');
            }
        },
		// 页码点击
		handlePageSize(index){
			console.log(index,this.pageSize);
			console.log(this.page_index);
			 if(index>this.pageSize){
				return
			};
			this.page_index = index;
			this.getEquiplist()
		},
		// 上个页码
		pageTop(){
			let pageArr = []
			this.pageSizeList.forEach(item=>{
			  item-=5
			  pageArr.push(item)
			})
			this.pageSizeList = pageArr;
		},
		// 下页码
		pageBottom(){
			let pageArr = []
			this.pageSizeList.forEach(item=>{
			  item+=5
			  pageArr.push(item)
			})
			this.pageSizeList = pageArr
		},
		// 上一页
		goTop(){
			if(this.deviceCount==0){
			  return
			};
			if(this.page_index==1){
			  this.$message.info(this.$t('ysdyy'))
			  return
			};
			this.page_index--;
			if(this.page_index<this.pageSizeList[0]){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				item-=5
				pageArr.push(item)
				})
				this.pageSizeList=pageArr,
				this.page_index=pageArr[4]
			}
			this.getEquiplist()
		},
		// 下一页
		goBottom(){
			if(this.deviceCount==0){
			  return
			}
			if(this.page_index==this.pageSize){
			  this.$message.info(this.$t('mygd'))
			  return
			}
			this.page_index++;
			if(this.page_index>this.pageSizeList[4]){
				let pageArr = []
				this.pageSizeList.forEach(item=>{
				item+=5
				pageArr.push(item)
				})
				this.pageSizeList=pageArr,
				this.page_index=pageArr[0]
			}
			this.getEquiplist()
		},
        // 获取设备列表
        onLoad() {
            this.page_index++;
            this.getEquiplist()
        },
        getEquiplist(){
            let data={
                method:'co.wx.device.list',
                user_id:this.UserInfo.user_id,
                page_index:this.page_index,
                page_size:this.page_size,
                keyword:this.keyword
            }
            this.$serve(data).then(res=>{
                console.log(res)
                if(res.data.code==0){
                    this.equdatalist = res.data.data;
					this.deviceCount = res.data.count;
					this.pageSize = Math.ceil(res.data.count/this.page_size);
                    this.loading = false;
                    this.count = res.data.count
                    if (res.data.data == [] || this.count.length === 0) {
                        // 加载结束
                        this.finished = true;
                        return;
                    }
                    // this.equdatalist = this.equdatalist.concat(res.data.data)
                    
                    if (this.equdatalist.length >= this.count) {
                        this.finished = true;
                    }
                }
            })
        },
        // 查询
        questlist(){
            this.getEquiplist()
        }
    }
}
</script>
<style scoped>
	.data-load-more{
		width: 100%;
		height: 50px;
		line-height: 50px;
		background-color: #eee;
		text-align: center;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
		margin-top: 20px;
	}
	/* 蓝牙弹窗样式 */
	.bluetooth-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}
	.bluetooth-modal {
		width: 85%;
		background-color: #fff;
		border-radius: 16px;
		overflow: hidden;
	}
	.modal-header {
		display: flex;
		align-items: center;
		padding: 20px 24px;
	}
	.warning-icon {
		width: 48px;
		height: 48px;
		background-color: #E74C3C;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 16px;
	}
	.modal-title {
		font-size: 18px;
		font-weight: bold;
		color: #333;
	}
	.modal-body {
		padding: 0 24px 20px;
	}
	.modal-body p {
		color: #666;
		font-size: 14px;
		line-height: 1.6;
		margin: 0;
		text-align: left;
	}
	.modal-footer {
		display: flex;
		padding: 16px 24px 24px;
		gap: 12px;
	}
	.btn-copy {
		flex: 1;
		height: 44px;
		background-color: #f5f5f5;
		color: #666;
		border: none;
		border-radius: 8px;
		font-size: 16px;
		cursor: pointer;
	}
	.btn-open {
		flex: 2;
		height: 44px;
		background-color: #2E86DE;
		color: #fff;
		border: none;
		border-radius: 8px;
		font-size: 14px;
		cursor: pointer;
	}
	.pageSizeBox{
		width: 50%;
		display: flex;
		justify-content: space-around;
	}
	.pageSizeItem{
	  width: 50rpx;
	}
	.pageSizeItemState{
	  color: #ff2146;
	  text-decoration: underline;
	}
.requist{
    width: 80%;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-around;
}
.requist >>> .van-cell{
    width: 180px;
    border: 1px solid #ccc;
    padding: 4px 6px;
    border-radius:4px ;
}
.equtcont{
    margin: 0 auto;
    width: 80%;
    /* border-left: 5px solid #C280FF; */
}
.equtcont h4 {
    text-align: left;
    margin-left:10px ;
}
.costplas{
    /* margin-left: 10px; */
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-top: 15px;
}
.yuan{
    /* margin: 0 auto; */
     width: 60px;
    height: 60px;
    border-radius:50% ;
    line-height: 70px;
    text-align: center;
    font-size: 38px;
    
}
.colors{
    color: #ccc;
    border: 1px solid #ccc;
}
.colorsold{
    color: #1ABC9C;
    border: 1px solid #1ABC9C;
}
.cents >>>.van-nav-bar__title{
    color: #fff;
}
.cents>>>.van-nav-bar .van-icon{
    color: #fff;
}
.cents>>>.van-nav-bar .van-nav-bar__text{
		color: #fff;
		font-size: 15px;
	}
</style>